import { render } from "./StartGameDialog.vue?vue&type=template&id=0ae91262"
import script from "./StartGameDialog.vue?vue&type=script&lang=js"
export * from "./StartGameDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__